export const discardModalCopy = 'Are you sure you want to discard this prescription? You cannot undo this action.';
export const discardModalHeader = 'Discard prescription?';

export const discardRxCopy = 'Discard Rx';
export const cancelCopy = 'Cancel';
